<template>
  <div>
    <v-text-field dense outlined ref="time" v-mask="timeMask" :label="label" prepend-icon="mdi-clock-time-four-outline" :readonly="is_readonly"
          v-model="time_picked" :rules="required_time">
    </v-text-field>
    <!--<v-menu ref="start_time_menu" v-model="start_time_menu" min-width="350px" nudge-bottom="10"
      :close-on-content-click="false"
      :return-value.sync="time_picked"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field  :label="label" prepend-icon="mdi-clock-time-four-outline" readonly
          v-model="time_picked" v-bind="attrs" v-on="on" :rules="required">
        </v-text-field>
      </template>
      <v-time-picker :readonly="is_readonly" v-if="start_time_menu" :min="apply_min" :max="apply_max" format="24hr" v-model="time_picked" full-width @click:minute="$refs.start_time_menu.save(time_picked)">
      </v-time-picker>
    </v-menu>-->
  </div>
</template>

<script>
  import validations from "@/mixins/validations";
  export default {
    props: {
      label:  {
        type: String, 
      },
      max:  {
        type: String, 
      },
      min:  {
        type: String, 
      },
      is_job_end_same_day_event: {
        type: Boolean, 
        default: false,
      },
      is_job_start_same_day_event: {
        type: Boolean, 
        default: false,
      },
      is_job_start_end_same_day: {
        type: Boolean, 
        default: false,
      },
      is_job_start_in_final_day_event: {
        type: Boolean, 
        default: false,
      },
      is_end: {
        type: Boolean, 
        default: false,
      },
      is_start: {
        type: Boolean, 
        default: false,
      },
      is_component_show_event: {
        type: Boolean
      },
      time: {
        type: String
      },
      is_readonly: {
        type: Boolean
      },
      required_date: {
        type: Boolean,
        default: ()=> false
      }
    },
    name: 'CalendarTimePicker',
    mixins: [ validations ],
    data() {
      return {
        timeMask: '##:##',
        time_picked: null,
        start_time_menu: false,
      }
    },
    mounted() {
      this.setTime()
    },
    methods: {
      setTime(){
        if(this.is_component_show_event && this.time){
          this.time_picked= this.time
        }
      }
    },
    watch: {
      time_picked(nV) {
        if(this.$refs.time.validate()){
          this.$emit('timePicked', nV)
        }
      }
    },
    computed: {
    },
  }
</script>

<style lang="scss" scoped>

</style>